const mapper_options = {
  endpoint: 'locations_by_state',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      campaign: {
        foreignKey: 'campaign_id',
        localField: 'campaign'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('campaign_reporting_state_locations', mapper_options)
}
